import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { filter, first } from 'rxjs/operators';

import { GlitterOfferBaseDto } from '../../api/glitterOfferBaseDto';
import { ExchangeCartService } from '../exchange-cart.service';
import { ExchangeService } from '../exchange.service';
import { AuthService } from '../../shared/auth/auth.service';
import { defs } from '../../defs';
import { ExchangeQueryParameters } from '../../api/exchange.query';

const sortByTranslationKeys = ['sortByOptions.glitterAmount', 'sortByOptions.priceInUsd', 'sortByOptions.like'];

@Component({
	selector: 'narwhalia-exchange-sidebar',
	templateUrl: './exchange-sidebar.component.html',
	styleUrls: ['./exchange-sidebar.component.scss']
})
export class ExchangeSidebarComponent extends OnDestroyMixin implements OnInit {
	packageSort: FormGroup;
	sortByParams: any[];
	showCartPopup: boolean;
	cartQuantitySum: number;
	isLoggedIn: boolean;

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private exchangeService: ExchangeService,
		private exchangeCartService: ExchangeCartService,
		private translateService: TranslateService,
		private authService: AuthService
	) {
		super();
		this.translateService.get(sortByTranslationKeys).subscribe(sortByOptions => {
			const [glitterAmount, price, like] = sortByTranslationKeys;
			this.sortByParams = [
				{ viewValue: sortByOptions[glitterAmount], value: 'glitterAmount' },
				{ viewValue: sortByOptions[price], value: 'price' },
				{ viewValue: sortByOptions[like], value: 'like' }
			];
		});
		this.createForm();
	}

	createForm() {
		this.packageSort = this.fb.group({
			sortBy: [defs.sortOrders.defaults.exchange],
			own: [undefined]
		});
	}

	patchForm = queryParams => {
		const { own, sortBy } = queryParams;
		this.packageSort.patchValue({
			sortBy,
			own
		});
	};

	ngOnInit() {
		this.exchangeService.queryParams$.pipe(first(queryParams =>
			Object.keys(queryParams).length > 0)).subscribe(queryParams => {
			this.patchForm(queryParams);
			this.packageSort.valueChanges.subscribe(this.refreshUrlQueryParams);
		});
		this.authService
			.isLoggedInAsObservable()
			.pipe(
				filter(isLoggedIn => !!isLoggedIn === true),
				untilComponentDestroyed(this)
			)
			.subscribe(isLoggedIn => {
				this.isLoggedIn = isLoggedIn;
				//this.exchangeService.getExchangeCart().subscribe((cart: GlitterCartDto) => this.exchangeCartService.initCart(cart));
				//this.exchangeCartService.cart$
				this.exchangeCartService.getCart(this)
					.subscribe(cart => {
					if (this.cartQuantitySum === 0) {
						this.showCartPopup = false;
					}
					this.cartQuantitySum = this.sumCartQuantites(cart);
				});
			});
	}

	sumCartQuantites = (cart: Map<GlitterOfferBaseDto, number>) =>
		Array.from(cart.keys()).reduce((accumulator, glitter: GlitterOfferBaseDto) =>
							accumulator + glitter.amount * cart.get(glitter), 0);

	refreshUrlQueryParams = ({ own, sortBy }) => {
		let queryParams: ExchangeQueryParameters = { sortBy };
		if (own) {
			queryParams = { ...queryParams, own: 1 };
		}
		this.router.navigate(['exchange'], { queryParams });
	};

	toggleCartPopup(event) {
		event.stopPropagation();
		this.showCartPopup = !this.showCartPopup;
	}
}